import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
//pour AppBar
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';

// Composants stylisés
export const GreenBorderCard = styled(Card)(({ theme }) => ({
  borderRadius: 28,
  border: '0.25px solid #44fb8c',
  boxShadow: 'none',
}));

export const SecondaryColoredBorderCard = styled(Card)(({ theme, borderWidth }) => ({
  borderRadius: 6,
  border: `${borderWidth || 0.25}px solid ${theme.palette.secondary.main}`,
  boxShadow: 'none',
}));

export const InvisibleCard = styled(Card)(({ theme }) => ({
  borderRadius: 19,
  border: '0.25px solid #FFFFFF',
  boxShadow: 'none',
}));

export const FullWidthForm = styled(Box)(({ theme }) => ({
  width: '100%', // Fix IE 11 issue
}));

//pour VcDialog.js
export const SmallAvatar = styled('div')(({ theme }) => ({ //Utilisé par SmartGuard.js
  width: 12,
  height: 12,
}));

export const MediumAvatar = styled('div')(({ theme }) => ({ //Utilisé EditJournalEntryDialog.js
  width: 14,
  height: 14,
}));

//Pour Dashboard.jsx 
export const StyledCardDb = styled(Card)(({ theme }) => ({
  borderRadius: 19,
  border: '0.25px solid #DCDCDC',
  boxShadow: 'none',
  padding: theme.spacing(2), // Ajout d'un padding si nécessaire
  backgroundColor: theme.palette.background.paper, // Exemple de couleur de fond
}));

// Pour Overview.js
export const OverviewCard = styled(Card)(({ theme }) => ({
  borderRadius: 19,
  border: '0.25px solid #DCDCDC',
  boxShadow: 'none',
}));


//aussi utiliser par EquivIcon.js
export const OverviewCardT = styled(Card)(({ theme }) => ({
  borderRadius: 19,
  border: '0.25px solid #FFFFFF',
  boxShadow: 'none',
}));

//Pour SmartGuard.js
export const SmartGuardCard = styled(Card)(({ theme }) => ({
  borderRadius: 19,
  border: '0.25px solid #DCDCDC',
  boxShadow: 'none',
}));

export const SmartGuardCardT = styled(Card)(({ theme }) => ({
  borderRadius: 19,
  border: '0.25px solid #FFFFFF',
  boxShadow: 'none',
}));

//pour AlarmDialog.js , MutedDialog.js utilise le même, ... , EditJournalEntryDialog.js
// et aussi VcDialog.js , ParamDialog.js
export const StyledAppBar = styled(AppBar)(({ theme }) => ({
  position: 'relative',
}));


export const StyledTitle = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(2),
  flex: 1,
}));
//pour AppBar 
export const StyledAppBarForAppBar = styled(AppBar)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    zIndex: theme.zIndex.drawer + 1,
    position: 'top',
  },
  backgroundColor: '#ffffff',
}));

export const StyledBackIcon = styled(ArrowBackIosNewRoundedIcon)(({ theme }) => ({
  color: '#9a9a9a',
  fontSize: theme.typography.pxToRem(16), // Exemple pour gérer la taille
}));


//POur EditJournalEntryDialog.js
export const StyledForm = styled('form')(({ theme }) => ({
  width: '100%',
}));

//Pour Menu
export const MenuAvatar = styled('avatar')(({ theme }) => ({
  width: theme.spacing(7),
  height: theme.spacing(7),
  [theme.breakpoints.down('md')]: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
}));
//pour equivon  (pas obligatoire car overviewCardT)
export const EquivIconCard = styled(Card)(({ theme }) => ({
  borderRadius: 19,
  border: '0.25px solid #FFFFFF',
  boxShadow: 'none',
}));




//Pour VCDialogs.jss 



//Migré depuis makeStlye.js 

/*
import { makeStyles } from '@material-ui/core/styles'

const custom_theme = localStorage.getItem('custom-theme')

export const getPrimaryColor = () => {
  switch (custom_theme) {
    case 'sinyon':
      return '#576FF2'
    default:
      return '#a6ce34'
  }
}

export const useStyles = makeStyles({
  form: {
    width: '100%' // Fix IE 11 issue.
  },
  card: {
    borderRadius: 19,
    border: '0.25px solid #DCDCDC',
    boxShadow: 'none'
  },
  invisible_card: {
    borderRadius: 19,
    border: '0.25px solid #FFFFFF',
    boxShadow: 'none'
  },
  avatar: {
    width: 12,
    height: 12
  },
  divider: {
    // Theme Color, or use css color in quote
    background: custom_theme ? getPrimaryColor() : '#a6ce34'
  }
})
*/